import { ListItem, ListItemText, TextField } from '@mui/material'

const patterns = {
  email: "^(?![_.-])((?![_.-][_.-])[a-zA-Z\d_.-]){0,63}[a-zA-Z\d]@((?!-)((?!--)[a-zA-Z\d-]){0,63}[a-zA-Z\d]\.){1,2}([a-zA-Z]{2,14}\.)?[a-zA-Z]{2,14}$",
  phone: "[0-9]{5}[-][0-9]{7}[-][0-9]{1}"
}

const Item = ({ title, client, clientCopy, field, change, editing, format, required, error, helperText }) => {
  if (editing) return (
    <ListItem alignItems="flex-start">
      <ListItemText secondary={title} className='text-gray-300' />
      <TextField
        value={clientCopy[field] ?? ""}
        multiline={format === "multiline"}
        rows={6}
        onChange={e => change(field, e)}
        sx={{ width: 500 }}
        required={required}
        label={title}
        error={error}
        helperText={helperText}
        slotProps={{ inputLabel: { shrink: true }, htmlInput: { pattern: patterns[format] } }}
      />
    </ListItem>
  )
  else return (
    <ListItem alignItems="flex-start">
      <ListItemText secondary={title} className='text-gray-300' style={{ width: 200 }} />
      <ListItemText primary={client?.[field]} style={{ whiteSpace: "pre-wrap" }} slotProps={{
        root: { sx: { textAlign: 'left', width: '100%' } },
        primary: { sx: { textAlign: 'left' } },
      }} />
    </ListItem>
  )
}

export default Item